import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";

import DropDown from "../Common/Forms/DropDown";
import CreateModals from "./CreateModals/CreateModals";

import ExportToExcelContainer from "./ExportToExcelContainer";
import GrunndataFilterContainer from "./GrunndataFilterContainer";

import AktorerList from "./Lists/AktorerList";
import BetjentList from "./Lists/BybetjentList";
import FargerList from "./Lists/FargerList";
import ForsinketMakuleringList from "./Lists/ForsinketMakuleringList";
import InternkoderList from "./Lists/InterkoderList";
import KjoretoyMerkerList from "./Lists/KjoretoyMerkerList";
import KjoretoyTyperList from "./Lists/KjoretoyTyperList";
import NasjonerList from "./Lists/NasjonerList";
import OvertredelseskoderIleggelseList from "./Lists/OvertredelseskoderIleggelseList";
import OvertredelseskoderMiljogebyrList from "./Lists/OvertredelseskoderMiljogebyrList";
import RettekoderList from "./Lists/RettekoderList";
import VedtakskoderList from "./Lists/VedtakskoderList";

import { getIleggelsestyper } from "../../actions/ileggelsestyperActions";
import { getInternkoderIleggelser } from "../../actions/internkoderIleggelserActions";
import { getInternkoderMiljogebyr } from "../../actions/internkoderMiljogebyrActions";
import { getKlageKoder } from "../../actions/klagekoderAction";
import { getOvertredelsegrupper } from "../../actions/overtredelsegrupperActions";
import {
    bypatruljen,
    bypatruljenAll,
    innsyn,
    juridisk,
    juridiskAll,
} from "../../constants/roles";
import { authorized } from "../../utils/authorizationUtils";

import sitePaths from "../../constants/sitePaths";
import * as title from "../../constants/titles";

import "./GrunndataPage.css";

export default function GrunndataPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const grunndataFilterForm = useSelector(
    (state) => state.forms.grunndataFilterForm
  );
  const internkoderIleggelser = useSelector(
    (state) => state.internkoderIleggelser
  );
  const internkoderMiljogebyr = useSelector(
    (state) => state.internkoderMiljogebyr
  );

  const authorizedAktorer = authorized([bypatruljen.saksbehandleradmin]);
  const authorizedBypatruljen = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedFarger = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedForsinketMakuleringMal = authorized([
    bypatruljen.saksbehandleradmin,
  ]);
  const authorizedIleggelseOvertredelseskoder = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.vaktsentralen,
    innsyn.serviceavdeling,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedKjoretoyTyper = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedKjoretoyMerker = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedMiljogebyrOvertredelseskoder = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.vaktsentralen,
    innsyn.serviceavdeling,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedIleggelseInternkoder = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.vaktsentralen,
    innsyn.serviceavdeling,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedMiljogebyrInternkoder = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.vaktsentralen,
    innsyn.serviceavdeling,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedNasjoner = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedRettekoder = authorized([
    ...bypatruljenAll,
    ...juridiskAll,
    innsyn.seksjonssjefVaktsentralen,
  ]);
  const authorizedVedtakskoder = authorized([
    bypatruljen.saksbehandleradmin,
    bypatruljen.avdelingdirektor,
    bypatruljen.seksjonssjefStab,
    bypatruljen.seksjonssjef,
    ...juridiskAll,
    innsyn.vaktsentralen,
    innsyn.serviceavdeling,
    innsyn.seksjonssjefVaktsentralen,
  ]);

  const [valgtGrunndata, setValgtGrunndata] = useState("Velg grunndata");
  const [authorizedToCreateAndEdit, setAuthorizedToCreateAndEdit] =
    useState(false);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  const handleSelectOptionGrunndataChange = useCallback(
    (value) => {
      let auth;
      switch (value) {
        case "Aktører":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.aktorer);
          break;
        case "Bypatruljen":
          auth = authorized([
            bypatruljen.saksbehandler,
            bypatruljen.saksbehandleradmin,
            bypatruljen.avdelingdirektor,
            bypatruljen.seksjonssjefStab,
          ]);
          navigate(sitePaths.grunndata.bypatruljen);
          break;
        case "Farger":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.farger);
          break;
        case "Forsinket makulering":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.forsinketMakulering);
          break;
        case "Internkoder ileggelser":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.internkoderIleggelser);
          break;
        case "Internkoder miljøgebyr":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.internkoderMiljogebyr);
          break;
        case "Kjøretøytyper":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.kjoretoyTyper);
          break;
        case "Kjøretøymerker":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.kjoretoyMerker);
          break;
        case "Nasjoner":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.nasjoner);
          break;
        case "Overtredelseskoder ileggelser":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.overtredelseskoderIleggelser);
          break;
        case "Overtredelseskoder miljøgebyr":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.overtredelseskoderMiljogebyr);
          break;
        case "Rettekoder":
          auth = authorized([bypatruljen.saksbehandleradmin]);
          navigate(sitePaths.grunndata.rettekoder);
          break;
        case "Vedtakskoder":
          auth = authorized([juridisk.ledelse]);
          navigate(sitePaths.grunndata.vedtakskoder);
          break;
        default:
          auth = false;
          break;
      }
      setValgtGrunndata(value);
      setAuthorizedToCreateAndEdit(auth);
    },
    [navigate]
  );

  useEffect(() => {
    document.title = title.grunndata;
    dispatch(getInternkoderIleggelser());
    dispatch(getInternkoderMiljogebyr());
    dispatch(getOvertredelsegrupper());
    dispatch(getIleggelsestyper());
    dispatch(getKlageKoder());

    let valgtGrunndataFromPath = "Velg grunndata";
    if (location.pathname === sitePaths.grunndata.aktorer) {
      valgtGrunndataFromPath = "Aktører";
    } else if (location.pathname === sitePaths.grunndata.bypatruljen) {
      valgtGrunndataFromPath = "Bypatruljen";
    } else if (location.pathname === sitePaths.grunndata.farger) {
      valgtGrunndataFromPath = "Farger";
    } else if (
      location.pathname === sitePaths.grunndata.forsinketMakulering
    ) {
      valgtGrunndataFromPath = "Forsinket makulering";
    } else if (
      location.pathname === sitePaths.grunndata.internkoderIleggelser
    ) {
      valgtGrunndataFromPath = "Internkoder ileggelser";
    } else if (
      location.pathname === sitePaths.grunndata.internkoderMiljogebyr
    ) {
      valgtGrunndataFromPath = "Internkoder miljøgebyr";
    } else if (location.pathname === sitePaths.grunndata.kjoretoyTyper) {
      valgtGrunndataFromPath = "Kjøretøytyper";
    } else if (location.pathname === sitePaths.grunndata.kjoretoyMerker) {
      valgtGrunndataFromPath = "Kjøretøymerker";
    } else if (location.pathname === sitePaths.grunndata.nasjoner) {
      valgtGrunndataFromPath = "Nasjoner";
    } else if (
      location.pathname === sitePaths.grunndata.overtredelseskoderIleggelser
    ) {
      valgtGrunndataFromPath = "Overtredelseskoder ileggelser";
    } else if (
      location.pathname === sitePaths.grunndata.overtredelseskoderMiljogebyr
    ) {
      valgtGrunndataFromPath = "Overtredelseskoder miljøgebyr";
    } else if (location.pathname === sitePaths.grunndata.rettekoder) {
      valgtGrunndataFromPath = "Rettekoder";
    } else if (location.pathname === sitePaths.grunndata.vedtakskoder) {
      valgtGrunndataFromPath = "Vedtakskoder";
    }
    handleSelectOptionGrunndataChange(valgtGrunndataFromPath);

    const resizeHandler = () => setInnerWidth(window.innerWidth);
    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, handleSelectOptionGrunndataChange]);

  const getContentStyle = () => {
    if (
      valgtGrunndata === "Farger" ||
      valgtGrunndata === "Kjøretøymerker" ||
      valgtGrunndata === "Kjøretøytyper" ||
      valgtGrunndata === "Nasjoner" ||
      valgtGrunndata === "Rettekoder"
    ) {
      return { paddingRight: 50, paddingLeft: 50, maxWidth: 650 };
    }
    return { paddingRight: 50, paddingLeft: 50 };
  };

  const getTableStyle = () => {
    if (window.innerWidth < 768) {
      return { paddingRight: 0, paddingLeft: 0 };
    }
    return getContentStyle();
  };

  const getDropdownGrunndata = () => {
    let grunndata = [];

    grunndata = authorizedAktorer
      ? [...grunndata, { id: "Aktører", navn: "Aktører" }]
      : [...grunndata];

    grunndata = authorizedBypatruljen
      ? [...grunndata, { id: "Bypatruljen", navn: "Bypatruljen" }]
      : [...grunndata];

    grunndata = authorizedFarger
      ? [...grunndata, { id: "Farger", navn: "Farger" }]
      : [...grunndata];

    grunndata = authorizedForsinketMakuleringMal
      ? [
          ...grunndata,
          { id: "Forsinket makulering", navn: "Forsinket makulering" },
        ]
      : [...grunndata];

    grunndata = authorizedIleggelseInternkoder
      ? [
          ...grunndata,
          { id: "Internkoder ileggelser", navn: "Internkoder ileggelser" },
        ]
      : [...grunndata];

    grunndata = authorizedMiljogebyrInternkoder
      ? [
          ...grunndata,
          { id: "Internkoder miljøgebyr", navn: "Internkoder miljøgebyr" },
        ]
      : [...grunndata];

    grunndata = authorizedKjoretoyMerker
      ? [...grunndata, { id: "Kjøretøymerker", navn: "Kjøretøymerker" }]
      : [...grunndata];

    grunndata = authorizedKjoretoyTyper
      ? [...grunndata, { id: "Kjøretøytyper", navn: "Kjøretøytyper" }]
      : [...grunndata];

    grunndata = authorizedNasjoner
      ? [...grunndata, { id: "Nasjoner", navn: "Nasjoner" }]
      : [...grunndata];

    grunndata = authorizedIleggelseOvertredelseskoder
      ? [
          ...grunndata,
          {
            id: "Overtredelseskoder ileggelser",
            navn: "Overtredelseskoder ileggelser",
          },
        ]
      : [...grunndata];

    grunndata = authorizedMiljogebyrOvertredelseskoder
      ? [
          ...grunndata,
          {
            id: "Overtredelseskoder miljøgebyr",
            navn: "Overtredelseskoder miljøgebyr",
          },
        ]
      : [...grunndata];

    grunndata = authorizedRettekoder
      ? [...grunndata, { id: "Rettekoder", navn: "Rettekoder" }]
      : [...grunndata];

    grunndata = authorizedVedtakskoder
      ? [...grunndata, { id: "Vedtakskoder", navn: "Vedtakskoder" }]
      : [...grunndata];

    return grunndata;
  };

  return (
    <Container fluid>
      <Row>
        <Col>
          <div className="grunndata-fake-nav">
            <Row>
              <Col md={3}>
                <DropDown
                  items={getDropdownGrunndata()}
                  selected={valgtGrunndata}
                  title="Velg grunndata"
                  onChange={(e) =>
                    handleSelectOptionGrunndataChange(e.target.value)
                  }
                />
              </Col>
            </Row>
          </div>
          {valgtGrunndata && valgtGrunndata !== "Velg grunndata" && (
            <React.Fragment>
              <GrunndataFilterContainer />
              <div style={getContentStyle()}>
                <h1
                  className={
                    innerWidth > 699
                      ? "grunndata-page pull-left"
                      : "grunndata-page"
                  }
                >
                  {valgtGrunndata}
                </h1>
                <div
                  style={innerWidth > 699 ? { marginTop: 10 } : {}}
                >
                  {authorizedToCreateAndEdit && (
                    <>
                      {innerWidth > 699 && (
                        <CreateModals
                          createModalToRender={valgtGrunndata}
                        />
                      )}
                      {innerWidth < 700 && (
                        <div>
                          <CreateModals
                            createModalToRender={valgtGrunndata}
                          />
                        </div>
                      )}
                    </>
                  )}
                  {valgtGrunndata !== "Forsinket makulering" && (
                    <>
                      {innerWidth > 699 && (
                        <ExportToExcelContainer
                          excelClassNames={
                            innerWidth > 699 ? "pull-right" : ""
                          }
                          excelStyle={
                            innerWidth > 699
                              ? { marginRight: 10 }
                              : { marginTop: 10, marginBottom: 10 }
                          }
                        />
                      )}
                      {innerWidth < 700 && (
                        <div>
                          <ExportToExcelContainer
                            excelClassNames=""
                            excelStyle={{
                              marginTop: 10,
                              marginBottom: 10,
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="clearfix" />
              </div>
              <div style={getTableStyle()}>
                {authorizedAktorer &&
                  location.pathname === sitePaths.grunndata.aktorer && (
                    <AktorerList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedBypatruljen &&
                  location.pathname === sitePaths.grunndata.bypatruljen && (
                    <BetjentList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedFarger &&
                  location.pathname === sitePaths.grunndata.farger && (
                    <FargerList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedForsinketMakuleringMal &&
                  location.pathname ===
                    sitePaths.grunndata.forsinketMakulering && (
                    <ForsinketMakuleringList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedIleggelseInternkoder &&
                  location.pathname ===
                    sitePaths.grunndata.internkoderIleggelser && (
                    <InternkoderList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                      internkoder={Array.isArray(internkoderIleggelser) ? internkoderIleggelser.filter(
                        (iki) =>
                          iki.aktiv ===
                            grunndataFilterForm.internkoderIleggelserAktivStatus ||
                          grunndataFilterForm.internkoderIleggelserAktivStatus ===
                            null,
                      ) : []}
                      modalToRender="ileggelser"
                    />
                  )}
                {authorizedMiljogebyrInternkoder &&
                  location.pathname ===
                    sitePaths.grunndata.internkoderMiljogebyr && (
                    <InternkoderList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                      modalToRender="miljøgebyr"
                      internkoder={Array.isArray(internkoderMiljogebyr) ? internkoderMiljogebyr.filter(
                        (ikm) =>
                          ikm.aktiv ===
                            grunndataFilterForm.internkoderMiljogebyrAktivStatus ||
                          grunndataFilterForm.internkoderMiljogebyrAktivStatus ===
                            null,
                      ) : []}
                    />
                  )}
                {authorizedKjoretoyMerker &&
                  location.pathname === sitePaths.grunndata.kjoretoyMerker && (
                    <KjoretoyMerkerList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedKjoretoyTyper &&
                  location.pathname === sitePaths.grunndata.kjoretoyTyper && (
                    <KjoretoyTyperList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedNasjoner &&
                  location.pathname === sitePaths.grunndata.nasjoner && (
                    <NasjonerList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedIleggelseOvertredelseskoder &&
                  location.pathname ===
                    sitePaths.grunndata.overtredelseskoderIleggelser && (
                    <OvertredelseskoderIleggelseList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedMiljogebyrOvertredelseskoder &&
                  location.pathname ===
                    sitePaths.grunndata.overtredelseskoderMiljogebyr && (
                    <OvertredelseskoderMiljogebyrList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedRettekoder &&
                  location.pathname === sitePaths.grunndata.rettekoder && (
                    <RettekoderList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                    />
                  )}
                {authorizedVedtakskoder &&
                  location.pathname === sitePaths.grunndata.vedtakskoder && (
                    <VedtakskoderList
                      authorizedToCreateAndEdit={authorizedToCreateAndEdit}
                      modalToRender="vedtakskode"
                    />
                  )}
              </div>
            </React.Fragment>
          )}
        </Col>
      </Row>
    </Container>
  );
}
